export class UrlUtils {
  static isUrl = (value: string) => {
    let url: URL;

    try {
      url = new URL(value);
    } catch (_) {
      return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
  };

  static getQueryParam = (key: string) => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(key);
  };
}
